import { FC, ReactNode, useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router'

import { isInWorkingHours } from './date'
import { initIntercom } from './intercom'
import { useEventTracking } from './logging/tracking'

import { Channel } from 'types'

export const IntercomPostQuoteContainer: FC<{ quoteChannel?: Channel; children?: ReactNode }> = ({
  children,
  quoteChannel,
}) => {
  const track = useEventTracking()
  const location = useLocation()

  const pagesBeforeOverview: string[] = [
    '/direct',
    '/edit',
    '/plan-comparison',
    '/compare-the-market',
    '/go-compare',
    '/confused',
    '/quotezone',
    '/money-supermarket',
  ]

  const isPageAfterOverview = !pagesBeforeOverview.some((page) => location.pathname.includes(page))
  const isCreateAccountPage = location.pathname.includes('/create-account')
  const [hasInteractedWithIntercom, setHasInteractedWithIntercom] = useState<boolean>(false)
  const showMyLicenceIntercom = isCreateAccountPage

  const hasLoadedIntercom = useRef<boolean>(false)

  useEffect(() => {
    return () => {
      window.Intercom('shutdown')
    }
  }, [])

  useEffect(() => {
    if (hasInteractedWithIntercom || (showMyLicenceIntercom && isInWorkingHours())) {
      if (!hasLoadedIntercom.current) {
        initIntercom()

        window.Intercom('update', {
          hide_default_launcher: !hasInteractedWithIntercom,
        })

        window.Intercom('onShow', () => {
          track('clickOpenIntercom - postQuote')
          setHasInteractedWithIntercom(true)
        })

        hasLoadedIntercom.current = true
      }
    } else {
      window.Intercom('shutdown')
    }

    if (!isPageAfterOverview) {
      hasLoadedIntercom.current = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quoteChannel, hasInteractedWithIntercom, isPageAfterOverview, isCreateAccountPage])

  return <>{children}</>
}
